import './Common/sentry';

const w = window as any;

import jquery from 'jquery';
w.$ = w.jQuery = jquery;

import * as ko from 'knockout';
w.ko = ko;

import Dropzone from 'dropzone';
Dropzone.autoDiscover = false;
w.Dropzone = Dropzone;

import './setupDateFns';

import { toast } from './Common/Toast';
w.toast = toast;

import { ProfileViewModel } from './ViewModels/ProfileViewModel';
import { Utils } from './Common/Utils';

import { ConsultationTypeEnum } from './Common/enums';
import { BookEmailConsultationViewModel } from './ViewModels/consultations/BookEmailConsultationViewModel';
import { BookVideoConsultationViewModel } from './ViewModels/consultations/BookVideoConsultationViewModel';
import { StepProgress } from './ViewModels/StepProgress';
import { Log } from './Common/Log';
import { Heartbeat } from './Common/heartbeat';
import { AlertViewModel } from './ViewModels/AlertViewModel';
import { RateConsultation } from './ViewModels/consultations/RateConsultationViewModel';
import { ReceiveVideoCall } from './ViewModels/consultations/ReceiveVideoCallFromDoctor';
import { ProfileInsuranceViewModel } from './ViewModels/ProfileInsuranceViewModel';
import { ConsultationDetailsViewModel } from './ViewModels/consultations/ConsultationDetailsViewModel';
import { CallQualityFeedback } from './ViewModels/doctor/CallQualityFeedbackViewModel';
import { SelectPatientViewModel } from './ViewModels/consultations/SelectPatientViewModel';
import { ClockValidatorApp } from './features/clockValidator/ClockValidatorApp';

w.Hejdoktor = {
    ProfileViewModel: ProfileViewModel,
    Utils: Utils,
    ConsultationTypeEnum: ConsultationTypeEnum,
    BookEmailConsultationViewModel: BookEmailConsultationViewModel,
    BookVideoConsultationViewModel: BookVideoConsultationViewModel,
    StepProgress: StepProgress,
    Log: Log,
    AlertViewModel: AlertViewModel,
    RateConsultation: RateConsultation,
    ReceiveVideoCall: ReceiveVideoCall,
    ProfileInsuranceViewModel: ProfileInsuranceViewModel,
    ConsultationDetailsViewModel: ConsultationDetailsViewModel,
    Heartbeat: Heartbeat,
    CallQualityFeedback: CallQualityFeedback,
    SelectPatientViewModel: SelectPatientViewModel,
    ClockValidatorApp: ClockValidatorApp,
};
